// Fallback descriptions for symbols whose subscription payload carries none.
// Shared by the symbol actions drawer (proposal 17) and the symbol picker (proposal 20).
export const FALLBACK_DESCRIPTIONS: { [key: string]: string } = {
  EURUSD: "Euro to US Dollar",
  EURCHF: "Euro to Swiss Franc",
  EURJPY: "Euro to Japanese Yen",
  EURGBP: "Euro to British Pound",
  GBPUSD: "British Pound to US Dollar",
  GBPJPY: "British Pound to Japanese Yen",
  USDJPY: "US Dollar to Japanese Yen",
  USDCHF: "US Dollar to Swiss Franc",
  USDCAD: "US Dollar to Canadian Dollar",
  AUDUSD: "Australian Dollar to US Dollar",
  GOLD: "Gold Spot",
  US100: "NASDAQ 100 Index",
  US30: "Dow Jones Index",
  US500: "S&P 500 Index",
  US2000: "Russell 2000 Index",
  DE40: "German DAX Index",
};

/**
 * Resolve a human-readable symbol description: prefer a non-empty server
 * description, then the shared fallback map, then the ticker itself.
 */
export function getSymbolDescription(
  symbol: string,
  serverDescription?: string
): string {
  return serverDescription || FALLBACK_DESCRIPTIONS[symbol] || symbol;
}
